export default "__VITE_ASSET__DzexIb2p__"